import { Box, Typography } from "@mui/material";
import React from "react";
import logo from "Assets/Company/logo.png";

const Footer = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row", md: "row" },
        justifyContent: "space-between",
        backgroundColor: "#1e1e1e",
        fontSize: "1.5rem",
        fontWeight: "600",
        height: { xs: "auto", sm: "15rem", md: "15rem" },
        py: "2rem",
        px: { xs: ".5rem", sm: "4rem", md: "4rem" },
        gap: { xs: "2rem", sm: "0rem", md: "0rem" },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box sx={{ height: "9rem", width: "9rem" }}>
          <img
            src={logo}
            alt="No Preview"
            style={{
              height: "100%",
              width: "100%",
              objectFit: "cover",
              // mixBlendMode: "multiply",
            }}
            onError={(e) => {
              e.onerror = null;
              e.target.src = require("Assets/Images/no-preview.jpeg");
            }}
          />
        </Box>
        {/* <Typography variant="h6">AffiChain</Typography> */}
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <Typography variant="h6" fontWeight={500} sx={{ fontSize: "1.1rem" }}>
          Project Build-Up Range:
        </Typography>
        <Typography variant="body" fontWeight={400} sx={{ fontSize: "1.1rem" }}>
          Low-End Projects: 30 - 45 days
        </Typography>
        <Typography variant="body" fontWeight={400} sx={{ fontSize: "1.1rem" }}>
          Medium Projects: 45 - 90 days
        </Typography>
        <Typography variant="body" fontWeight={400} sx={{ fontSize: "1.1rem" }}>
          Large Projects: 60 - 150 days
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: { xs: ".4rem", sm: "1rem", md: "1rem" },
        }}
      >
        <Typography variant="body" fontWeight={400} sx={{ fontSize: "1.1rem" }}>
          <Typography
            variant="caption"
            fontWeight={500}
            sx={{ fontSize: "1.1rem" }}
          >
            Email:{" "}
          </Typography>
          <a
            href="mailto:vikasana60@gmail.com"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            vikasana60@gmail.com
          </a>
        </Typography>
        <Typography variant="body" fontWeight={400} sx={{ fontSize: "1.1rem" }}>
          <Typography
            variant="caption"
            fontWeight={500}
            sx={{ fontSize: "1.1rem" }}
          >
            Contact Number:{" "}
          </Typography>
          <a
            href="tel:+919319170619"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            +91 9319170619
          </a>
        </Typography>
        <Typography
          variant="body"
          fontWeight={400}
          sx={{
            fontSize: "1.1rem",
            // lineHeight: { xs: "1.5rem", sm: "none", md: "none" },
            // mb: { xs: "2rem", sm: "0rem", md: "0rem" },
          }}
        >
          <Typography
            variant="caption"
            fontWeight={500}
            sx={{ fontSize: "1.1rem" }}
          >
            Support:{" "}
          </Typography>
          Lifetime Technical with minimal yearly charges
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
